import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import styled from 'styled-components'
import GenericModal from '../../GenericModal'
import ThunderIcon from '../../../images/thunder.svg'

const Content = styled.div`
  padding: 16px 20px 17px 20px;

  ol {
    margin: 0px;
    padding-left: 28px;

    li {
      color: #2B2B2B;
      font-size: 14px;
      font-family: Lato-Regular;
      padding-left: 10px;
    }
  }

  p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    text-align: left;
    line-height: 22px;
    margin: 0;
    padding: 0;
  }
`

const Footer = styled.div`
  > button {
    height: 43px;
    width: 100%;
  }

  .popup-message-container {
    display: flex;
    padding-bottom: 16px;

    img {
      margin: auto 0 auto 16px;
    }

    .popup-message {
      margin: auto;
      display: inline-block;
      font-family: Lato-Regular;
      font-size: 12px;
    }
  }
`
export class SelectBrokerDialog extends Component {

  createAccountHandler = (openBlank) => this.props.onSelectedBroker(this.props.broker, openBlank)

  render() {
    const { t, broker, employee, content, viewOnly } = this.props;

    if (!this.props.visible) {
      return null
    }

    const jsonContent = JSON.parse(content)
    const brokerContent = jsonContent[this.props.broker.code]

    if (!brokerContent) {
      return null
    }

    let htmlContent = ''
    let readyDialog = true

    if (broker.code === 'FIDELITY') {

      if (!employee.broker_inumber) {
        // inumber NULL
        // Fidelity does not require an SSN and self-routes US vs OUS (no-SSN employees get an
        // iNumber), so eligibility must not be gated on valid_ssn_in or region (P470529165).
        readyDialog = employee.fidelity_activated_in !== null
      } else if(employee.fidelity_activated_in === null) {
        readyDialog = false
      }

      const parent = readyDialog ? brokerContent.withINumber : brokerContent.withoutINumber

      parent.forEach(el => {
        if (el.paragraphs) {
          htmlContent += el.paragraphs.map(p => {
            return `<p>${p}</p>`
          }).join('')
        } else if (el.list) {
          htmlContent += '<ol>' + el.list.map(li => `<li>${li}</li>`).join('') + '</ol>'
        }
      })
    } else {
      htmlContent = brokerContent.paragraphs.map(p => `<p>${p}</p>`).join('')
    }

    htmlContent = htmlContent.replace(/\{\{iNumber\}\}/g, `<b>${employee.broker_inumber || 'N/A'}</b>`)

    return (
      <GenericModal
        title={t('SelectBrokerDialog.Title', { broker: broker.name })}
        visible={true}
        onCloseDialog={this.props.onCloseDialog}
        width={420}
        className="select-broker"
      >
        <Content dangerouslySetInnerHTML={{ __html: htmlContent }} />
        <Footer>
          {readyDialog && (
            <div className="popup-message-container">
              <img src={ThunderIcon} alt="Thunder Icon"/>
              <p className="popup-message">{t('SelectBrokerDialog.PopupMessage')}</p>
            </div>
          )}
          <button className="primary-button create-account" disabled={viewOnly} onClick={() => this.createAccountHandler(readyDialog)}>{t('SelectBrokerDialog.CreateAccount', { broker: broker.name })}</button>
        </Footer>
      </GenericModal>
    )
  }
}

const mapState = state => ({
  content: state.static_content.select_and_pending_broker_dialog,
  employee: state.employee
});

export default connect(mapState)(withTranslation('translations')(SelectBrokerDialog))
